import { CheckIcon } from '@heroicons/react/24/solid'

interface Step {
  id: string
  title: string
  description: string
}

interface StepIndicatorProps {
  steps: Step[]
  currentStep: string
}

export function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  const getStepStatus = (stepId: string, _index: number) => {
    const currentIndex = steps.findIndex(step => step.id === currentStep)
    const stepIndex = steps.findIndex(step => step.id === stepId)

    if (stepIndex < currentIndex) return 'completed'
    if (stepIndex === currentIndex) return 'current'
    return 'upcoming'
  }

  return (
    <div className="flex items-center justify-center">
      {steps.map((step, index) => {
        const status = getStepStatus(step.id, index)
        const isLast = index === steps.length - 1

        return (
          <div key={step.id} className="flex items-center">
            {/* Step Circle */}
            <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 ${
              status === 'completed'
                ? 'bg-green-600 border-green-600 text-white'
                : status === 'current'
                ? 'border-blue-600 text-blue-600 bg-white'
                : 'border-gray-300 text-gray-400 bg-white'
            }`}>
              {status === 'completed' ? (
                <CheckIcon className="w-5 h-5" />
              ) : (
                <span className="text-sm font-medium">{index + 1}</span>
              )}
            </div>

            {/* Step Label */}
            <div className="ml-3 mr-8">
              <div className={`text-sm font-medium ${
                status === 'current' ? 'text-blue-600' : status === 'completed' ? 'text-green-600' : 'text-gray-500'
              }`}>
                {step.title}
              </div>
              <div className="text-xs text-gray-500 mt-1">
                {step.description}
              </div>
            </div>

            {/* Connector Line */}
            {!isLast && (
              <div className={`flex-1 h-0.5 mx-4 ${
                status === 'completed' ? 'bg-green-600' : 'bg-gray-300'
              }`} />
            )}
          </div>
        )
      })}
    </div>
  )
}